import React, { useState } from 'react';
import { Field } from 'formik';
import styled from '../../theme/styled-with-theme';
import { pxToRem } from '../../styles/utils';

const Input = styled(Field)`
  border: none;
  outline: 0;
  margin: ${({ theme }) =>
    `${theme.spacing.ml} ${theme.spacing.m} ${theme.spacing.m} ${theme.spacing.m}`};
  width: ${pxToRem(295)};
`;

interface LabelProps {
  active: boolean;
}

const Label = styled.label<LabelProps>`
  margin: ${({ theme }) =>
    `${theme.spacing.ml} ${theme.spacing.m} ${theme.spacing.m} ${theme.spacing.m}`};
  position: absolute;
  color: ${({ theme }) => theme.color.inputLabelText};
  transform: ${(props) => props.active && 'translate(-8px, -18px) scale(.75)'};
`;

const SelectLabel = styled.label<LabelProps>`
  margin: ${({ theme }) =>
    `${theme.spacing.ml} ${theme.spacing.m} ${theme.spacing.m} ${theme.spacing.m}`};
  position: absolute;
  color: ${({ theme }) => theme.color.selectInputLabelText};
  background-color: ${({ theme }) => theme.color.selectInputLabelBg};
  display: ${(props) => props.active && 'none'};
`;

const SelectInput = styled(Input)`
  background: transparent;
  width: ${pxToRem(300)};

  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-appearance: none;
  -moz-appearance: none;
`;

const InputContainer = styled('div')`
  height: ${({ theme }) => theme.spacing['2xl']};
  width: ${pxToRem(327)};
  border-radius: ${({ theme }) => theme.spacing.m};
  border-color: ${({ theme }) => theme.color.inputBorderColor};
  border-style: solid;
  border-width: ${pxToRem(1)};
  position: relative;
  font-size: ${pxToRem(18)};
`;

const SelectContainer = styled(InputContainer)`
  border: none;
  background-color: ${({ theme }) => theme.color.selectInputLabelBg};

  background-image: linear-gradient(45deg, transparent 50%, gray 50%),
    linear-gradient(135deg, gray 50%, transparent 50%),
    radial-gradient(white 70%, transparent 72%);
  background-position: calc(100% - 22px) calc(1em + 12px),
    calc(100% - 17px) calc(1em + 12px), calc(100% - 0.5em) 1em;
  background-size: 5px 5px, 5px 5px, 1.5em 1.5em;
  background-repeat: no-repeat;
`;

interface InputProps {
  name: string;
  label?: string;
  type: string;
  children?: any;
}

export function FormInput(props: InputProps) {
  const [active, setActive] = useState(false);

  return (
    <>
      {(props.type === 'text' || props.type === 'email') && (
        <InputContainer onFocus={() => setActive(true)}>
          <Label active={active} htmlFor={`${props.name}-input`}>
            {props.label}
          </Label>
          <Input
            id={`${props.name}-input`}
            name={`${props.name}`}
            type={`${props.type}`}
          />
        </InputContainer>
      )}
      {props.type === 'select' && (
        <SelectContainer onFocus={() => setActive(true)}>
          {props.label && (
            <SelectLabel active={active} htmlFor={`${props.name}-input`}>
              {props.label}
            </SelectLabel>
          )}
          <SelectInput
            as="select"
            id={`${props.name}-input`}
            name={`${props.name}`}
          >
            {props.children}
          </SelectInput>
        </SelectContainer>
      )}
    </>
  );
}
